<template>
  <span class="edit-text-container" v-if="!editMode" @click="editMode = true">
    {{valueFormatted}}
    <feather-icon v-if="value !== oldValue" class="updated-icon float-right" icon="AlertCircleIcon" />
  </span>
  <span v-else>
    <div class="center contents-input">
      <vs-input
          icon-after
          :value="value"
          @keyup.native.prevent="changeText"
          @keyup.native.esc="editMode = false">
        <template #icon>
          <feather-icon icon="AlertCircleIcon" />
        </template>
      </vs-input>
    </div>
  </span>
</template>

<script>
import {currency} from "@/filters/currency";

export default {
  name: "EditTextComponent",
  props: ["value", 'isCurrency'],
  data: () => ({
    editMode: false,
    oldValue: ''
  }),
  computed: {
    valueFormatted() {
      return this.isCurrency ? this._currency(this.value, 0): this.value;
    }
  },
  filters: {
    ...currency
  },
  mounted() {
    this.oldValue = this.value
  },
  methods: {
    _currency(value, d) {
      return currency(value, d)
    },
    changeText(ev) {
      if(ev.key === "Enter") {
        this.editMode = false;
        this.$emit("change", ev.target.value)
        this.$emit("input", ev.target.value)
        this.$emit("onAcceptChanges", ev.target.value)
      }
    }
  }
}
</script>

<style scoped>
.updated-icon {
  color: #cbb956 !important;
}
.edit-text-container {
  text-decoration: underline dotted red;
}
</style>
